<template>
  <div>
    <el-dialog
      :visible.sync="dialogCodeVisible"
      :append-to-body="true"
      fullscreen
    >
      <div class="dialog-box" @click="dialogCodeVisible = false">
        <div class="dialog-close" @click="dialogCodeVisible = false">
          <i class="el-icon-error"></i>
        </div>
        <img
          class="dialog-bg"
          :src="fileObj.auditValue ? fileObj.auditValue : fileObj.value"
          alt=""
        />
        <div class="dialog-button">
          <el-button plain @click.stop="handleDownloadOriginal"
            >下载原图</el-button
          >
          <el-button
            plain
            v-if="fileObj.auditValue"
            @click.stop="handleDownloadReview"
            >下载审核图</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PrescriptionImage",
  components: {},
  props: {
    fileObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogCodeVisible: false,
    };
  },
  methods: {
    show() {
      this.dialogCodeVisible = true;
    },
    handleDownloadOriginal() {
      this.downloadImage(this.fileObj.value, this.fileObj.text);
    },
    handleDownloadReview() {
      this.downloadImage(this.fileObj.auditValue, this.fileObj.auditText);
    },
    downloadImage(url, name) {
      if (!url) return;
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = name;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);
        });
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog {
  background: transparent;
  box-shadow: none;
}
::v-deep .el-dialog__header {
  display: none;
}
::v-deep .el-dialog__body {
  background: transparent;
  padding: 0 !important;
}
</style>
<style lang="scss" scoped>
@import "./index.scss";
</style>
